import React from 'react';
import { Link } from 'react-router-dom';
import PageSEO from '../components/PageSEO';

export default function ForbiddenPage() {
  return (
    <div className="bg-stone-100 min-h-[75vh] flex items-center justify-center pt-36 sm:pt-44 pb-20 px-4">
      <PageSEO
        title="403 - Adgang nægtet | KTS-Entreprise A/S"
        description="Du har ikke tilladelse til at tilgå denne side på KTS-Entreprise A/S."
        slug="403"
      />

      <div className="max-w-xl w-full bg-white border-2 border-stone-300 p-8 sm:p-12 shadow-sm text-center">
        <div className="w-16 h-16 bg-red-900 text-white font-heading font-black text-2xl flex items-center justify-center mx-auto mb-6">
          403
        </div>

        <h1 className="text-3xl font-black uppercase text-stone-900 tracking-tight font-heading mb-3">
          Adgang Nægtet
        </h1>

        <p className="text-stone-600 text-sm leading-relaxed mb-8">
          Du har ikke adgangstilladelse til denne ressource. Hvis du mener dette er en fejl, bedes du kontakte KTS-Entreprise A/S.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8 text-xs font-heading font-bold uppercase tracking-wider">
          <Link
            to="/"
            className="bg-[#0072c0] hover:bg-[#005b99] text-white py-3 px-4 transition-all duration-200 hover:scale-105 active:scale-95 flex items-center justify-center gap-2 cursor-pointer"
          >
            <i className="fa-solid fa-house"></i>
            <span>Gå til Forsiden</span>
          </Link>
          <Link
            to="/kontakt"
            className="bg-stone-900 hover:bg-stone-800 text-white py-3 px-4 transition-all duration-200 hover:scale-105 active:scale-95 flex items-center justify-center gap-2 cursor-pointer"
          >
            <i className="fa-solid fa-envelope"></i>
            <span>Kontakt os</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
